export { default as List } from './page'



// WEBPACK FOOTER //
// ./src/pages/list/index.js